import HLRU from 'hashlru';

function getLruCache(cacheSize) {
  if (cacheSize >= 1) {
    return HLRU(cacheSize);
  }

  return {
    get: function get() {
      return undefined;
    },
    set: function set() {}
  };
}

export { getLruCache };
//# sourceMappingURL=lru-cache.mjs.map
